import { ModelCollection } from '@/modules/core/app/models/ModelCollection';
import { ContactCreditor } from '@/modules/contact/models/ContactCreditor';

export class ContactCreditorCollection extends ModelCollection<ContactCreditor> {
  constructor(items: ContactCreditor[] | null = null) {
    super(items, ContactCreditor);
  }

  static mapModel(items: ContactCreditor[] | null = null): ContactCreditorCollection {
    return new this(items);
  }
}
